import React from 'react'
import { EmailContainer } from 'organisms/EmailSetting/container'

export const Email = () => (
  <React.Fragment>
    <EmailContainer />
  </React.Fragment>
)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Email/index.js